import { render, staticRenderFns } from "./StructuredSearch.vue?vue&type=template&id=6b9a4060&scoped=true&"
import script from "./StructuredSearch.vue?vue&type=script&lang=js&"
export * from "./StructuredSearch.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./StructuredSearch.vue?vue&type=style&index=1&id=6b9a4060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a4060",
  null
  
)

export default component.exports